import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_invoices_show_invoice = _resolveComponent("invoices-show-invoice")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.agreement.isReadyForPublication)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 0,
          label: "Mark as ready for publication",
          color: "primary",
          onClick: _ctx.onMarkAsReadyForPublication,
          unelevated: "",
          "no-caps": ""
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_btn, {
      label: "Manage Members",
      color: "primary",
      onClick: _ctx.onManageMembers,
      unelevated: "",
      "no-caps": ""
    }, null, 8, ["onClick"]),
    _createVNode(_component_q_btn, {
      label: "Change billing info",
      color: "primary",
      onClick: _ctx.onChangeBillingInfo,
      unelevated: "",
      "no-caps": ""
    }, null, 8, ["onClick"]),
    (_ctx.agreement.status !== 'draft' && !_ctx.isAgreementExpired)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 1,
          label: "Cancel Agreement",
          color: "primary",
          onClick: _ctx.onCancelAgreement,
          unelevated: "",
          "no-caps": ""
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_btn, {
      label: "Invoice preview",
      color: "primary",
      onClick: _ctx.onInvoicePreview,
      unelevated: "",
      "no-caps": ""
    }, null, 8, ["onClick"]),
    (_ctx.isAbleToCreateInvoice)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 2,
          label: "Create invoice",
          color: "primary",
          onClick: _ctx.onCreateInvoiceForAgreement,
          unelevated: "",
          "no-caps": ""
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.agreement.status === 'draft')
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 3,
          label: "Remove this draft",
          color: "primary",
          onClick: _ctx.onRemoveDraft,
          unelevated: "",
          "no-caps": ""
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.agreement.formEnabled && !_ctx.isAgreementExpired)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 4,
          label: "Disable agreement form",
          color: "primary",
          onClick: _ctx.onDisableAgreementForm,
          unelevated: "",
          "no-caps": ""
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (!_ctx.agreement.formEnabled && !_ctx.isAgreementExpired)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 5,
          label: "Enable agreement form",
          color: "primary",
          onClick: _ctx.onEnableAgreementForm,
          unelevated: "",
          "no-caps": ""
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.invoicePreviewVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.invoicePreviewVisible) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_invoices_show_invoice, {
          invoice: _ctx.invoicePreview,
          "preview-mode": ""
        }, null, 8, ["invoice"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}